import styled from '@emotion/styled';
import { device, typography } from '@landsbankinn/ui';
import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

interface IProps {
  id: string;
  children: React.ReactNode;
  subHeading: React.ReactNode;
  onChange: (id: string) => void;
}

const Host = styled.article`
  padding-top: 60px;
  min-height: 100vh;

  @media ${device.tablet} {
    padding-top: 0;
    padding-bottom: 80vh;
  }

  div {
    p:first-child {
      ${typography.p2}
      margin-bottom: calc(${64 / 24} * 1em);
    }
  }
`;

const IsMobile = styled.div`
  @media ${device.tablet} {
    display: none;
  }
`;

export const Chapter = ({ id, children, subHeading, onChange }: IProps) => {
  const [ref, inView] = useInView({
    threshold: 0.1,
    rootMargin: '0px 0px -200px 0px',
  });

  useEffect(() => {
    if (inView) {
      onChange(id);
    }
  }, [inView]);

  return (
    <Host id={id}>
      <IsMobile>{subHeading}</IsMobile>
      <div ref={ref}>{children}</div>
    </Host>
  );
};
